import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-organizer-shared-edit-live-url-section',
  templateUrl: './edit-live-url-section.component.html',
})
export class OrganizerSharedEditLiveUrlSectionComponent {
  @Input() public link: string;
  @Input() public liveUrl: string;
  @Input() public noteForAttendees: string;
}
